/* eslint-disable react/forbid-elements */
import * as React from 'react';

export const HighwaysIcon: React.FunctionComponent<object> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9">
    {/*tslint:disable-next-line:max-line-length*/}
    <path
      fill="var(--decorative-theme-black)"
      fillOpacity=".54"
      fillRule="evenodd"
      d="M9.729.568C9.607.236 9.264 0 8.86 0H2.14a.917.917 0 0 0-.868.568L0 3.938v4.5C0 8.746.275 9 .611 9h.611c.336 0 .611-.253.611-.563v-.562h7.334v.563c0 .309.275.562.61.562h.612c.336 0 .611-.253.611-.563v-4.5L9.729.568zm-7.59 5.62c-.507 0-.917-.377-.917-.844 0-.467.41-.844.917-.844.507 0 .917.377.917.844 0 .467-.41.843-.917.843zm6.722 0c-.507 0-.917-.377-.917-.844 0-.467.41-.844.917-.844.507 0 .917.377.917.844 0 .467-.41.843-.917.843zM1.222 3.374L2.14.844H8.86l.917 2.531H1.222z"
    />
  </svg>
);
